/**
 * ChallengeEdge - Red dashed edge for Devil's Advocate connections
 */

import React from 'react';
import { BaseEdge, getBezierPath } from '@xyflow/react';

const ChallengeEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  label,
  selected,
}) => {
  const [edgePath] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  return (
    <BaseEdge
      id={id}
      path={edgePath}
      style={{
        stroke: selected ? '#f87171' : '#ef4444',
        strokeWidth: 2,
        strokeDasharray: '8,4',
        opacity: 0.7,
      }}
      className="animate-dash-reverse"
    />
  );
};

export default ChallengeEdge;
